import React, { useState, useEffect } from 'react';
import LinkPreview from './LinkPreview';
import { formatSlackMessage } from '../utils/messageFormatter';

function MessageWithLinkPreview({ message, users }) {
  const [links, setLinks] = useState([]);
  const [hiddenPreviews, setHiddenPreviews] = useState(new Set());

  useEffect(() => {
    if (!message.text) {
      setLinks([]);
      return;
    }

    // Extract URLs from the message
    // Handle both plain URLs and Slack-formatted URLs <http://example.com|text>
    const urlRegex = /<(https?:\/\/[^|>]+)(?:\|[^>]+)?>/g;
    const plainUrlRegex = /(https?:\/\/[^\s<>"]+)/g;

    const slackUrls = [];
    let match;

    // First extract Slack-formatted URLs
    while ((match = urlRegex.exec(message.text)) !== null) {
      slackUrls.push(match[1]);
    }

    // Then extract plain URLs that aren't already in Slack format
    const plainMatches = message.text.match(plainUrlRegex) || [];
    const allUrls = [...slackUrls];

    for (const url of plainMatches) {
      // Only add if not already captured as Slack URL
      if (!message.text.includes(`<${url}`)) {
        allUrls.push(url);
      }
    }

    // Remove duplicates and filter out invalid URLs
    const uniqueLinks = [...new Set(allUrls)].filter(url => {
      try {
        new URL(url);
        return true;
      } catch {
        return false;
      }
    });

    setLinks(uniqueLinks);
  }, [message.text]);

  const handleDismissPreview = (link) => {
    setHiddenPreviews(prev => new Set([...prev, link]));
  };

  return (
    <>
      <div
        className="message-text"
        dangerouslySetInnerHTML={{ __html: formatSlackMessage(message.text, users) }}
      />
      {links.length > 0 && (
        <div className="message-link-previews">
          {links.map((link, index) => {
            if (hiddenPreviews.has(link)) return null;
            return (
              <div key={`${message.ts}-${index}`} className="message-link-preview">
                <LinkPreview url={link} onRemove={() => handleDismissPreview(link)} />
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}

export default MessageWithLinkPreview;